/**
 * Terms and privacy acceptance (`app/services/acceptance_service.py`).
 *
 * Split out of `brainfocus_api.ts` (FE Arch 1.0, #1165), which re-exports everything
 * here through the `BrainFocusApi` facade. Requests go through `client.request` so tests
 * can stub it on the module namespace.
 */
import * as client from '@brainfocus/web/api/client';
import { assertPojo } from '@brainfocus/web/api/response';

/**
 * Record a re-acceptance of the active Terms of Service / Privacy Policy
 * for the currently logged-in user (#555). Triggered from the
 * /accept-terms page when the login gate has blocked the user.
 */
export async function acceptTerms(): Promise<{ accepted: boolean }> {
    const response = await client.request('POST', '/api/accept-terms', {});
    assertPojo<{ accepted: boolean }>(response);
    return response;
}
